import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnPeopleProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M12 15.331c-3.775 0-7 .576-7 2.884 0 2.309 3.205 2.906 7 2.906 3.777 0 7-.577 7-2.885s-3.204-2.905-7-2.905M11.837 12.142c2.577 0 4.667-2.073 4.667-4.631s-2.09-4.632-4.668-4.632C9.26 2.879 7.17 4.952 7.17 7.51c-.009 2.548 2.065 4.622 4.635 4.631z"
      clipRule="evenodd"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnPeopleProfile;
